import { render } from "./GenericPage.vue?vue&type=template&id=1f0351bc&scoped=true"
import script from "./GenericPage.vue?vue&type=script&lang=ts"
export * from "./GenericPage.vue?vue&type=script&lang=ts"

import "./GenericPage.vue?vue&type=style&index=0&id=1f0351bc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1f0351bc"

export default script